import http from "../http-common";

class reportService {

  getTableData(data) {
    return http.post("/report/gettabledata", data);
  }

}

export default new reportService();
